import { render, staticRenderFns } from "./indexForSearch.vue?vue&type=template&id=37a5771a&scoped=true&"
import script from "./indexForSearch.vue?vue&type=script&lang=ts&"
export * from "./indexForSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5771a",
  null
  
)

export default component.exports